import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './TicketValidation.module.scss';

import { scanTicket } from 'legacy/actions/hostActions';
import Spinner from '../../util/Spinner/Spinner';

import ModalBase, { BaseModalProps } from '../ModalBase/ModalBase';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

interface TicketValidationProps {
  qrData?: string;
  eventId: string;
  scanTicket: (eventId: string, qrData: string) => void;
  close: () => void;
  scanCallback: () => void;
  events: Record<string, { title: string }>;
  baseModalProps: BaseModalProps;
  loading: { SCAN_TICKET: boolean };
  validated?: boolean;
  error?: { message: string };
}

class TicketValidation extends Component<TicketValidationProps> {
  componentDidMount() {
    if (this.props.qrData) {
      this.props.scanTicket(this.props.eventId, this.props.qrData);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.qrData !== this.props.qrData) {
      this.props.scanTicket(this.props.eventId, this.props.qrData);
    }
  }

  scanAgain = () => {
    this.props.close();
    this.props.scanCallback();
  };

  render() {
    const eventTitle = this.props.events[this.props.eventId]
      ? this.props.events[this.props.eventId].title
      : 'the event';
    return (
      <ModalBase
        baseModalProps={this.props.baseModalProps}
        back_img="Back"
        contentClassName="basic"
      >
        <div className={styles.TicketValidation}>
          {!this.props.loading.SCAN_TICKET ? (
            <>
              <div>
                {this.props.validated
                  ? `Guest has paid for ${eventTitle}`
                  : this.props.error
                  ? this.props.error.message
                  : 'Could not validate ticket'}
              </div>
              <Button className="scan" type={ButtonType.Primary} onClick={this.scanAgain}>
                SCAN ANOTHER
              </Button>
            </>
          ) : (
            <Spinner height={60} width={60} />
          )}
        </div>
      </ModalBase>
    );
  }
}

function mapStateToProps(state) {
  return {
    validated: state.host.validated,
    events: state.events.events,
    loading: state.host.loading,
    error: state.host.errors.SCAN_TICKET
  };
}

const actions = { scanTicket };

export default connect(mapStateToProps, actions)(TicketValidation as any);
